/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_Sent_NoneInputs */

const en_us2_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in sent · no soreness`)
};

const pt_br2_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in enviado · sem dor`)
};

const es_419_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in enviado · sin dolor`)
};

const pt_pt2_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in enviado · sem dor`)
};

const fr_fr2_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan envoyé · pas de courbatures`)
};

const de_de2_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in gesendet · kein Muskelkater`)
};

const it_it2_today_checkin_sent_none = /** @type {(inputs: Today_Checkin_Sent_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in inviato · nessun dolore`)
};

/**
* | output |
* | --- |
* | "Check-in sent · no soreness" |
*
* @param {Today_Checkin_Sent_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_sent_none = /** @type {((inputs?: Today_Checkin_Sent_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Sent_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_sent_none(inputs)
	if (locale === "es-419") return es_419_today_checkin_sent_none(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_sent_none(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_sent_none(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_sent_none(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_sent_none(inputs)
	return en_us2_today_checkin_sent_none(inputs)
});
export { today_checkin_sent_none as "today.checkin_sent_none" }